import { render, staticRenderFns } from "./ajuste-estoque.vue?vue&type=template&id=059fb469&scoped=true&"
import script from "./ajuste-estoque.vue?vue&type=script&lang=js&"
export * from "./ajuste-estoque.vue?vue&type=script&lang=js&"
import style0 from "./ajuste-estoque.vue?vue&type=style&index=0&id=059fb469&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059fb469",
  null
  
)

export default component.exports